import FirebaseHandler from "../../firebase";
import { httpsCallable } from "firebase/functions";
export const buyMagazine = async (data) => {
    const magazineBuy = httpsCallable(FirebaseHandler.functions, "magazineBuy");
    return magazineBuy(data);
};
